import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_add_client_btn = _resolveComponent("add-client-btn")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_app_user = _resolveComponent("app-user")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_user_status = _resolveComponent("user-status")!
  const _component_humanize_time = _resolveComponent("humanize-time")!
  const _component_actions_dropdown = _resolveComponent("actions-dropdown")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_ctx.isGranted('VIEW_CLIENTS'))
    ? (_openBlock(), _createBlock(_component_q_table, _mergeProps({
        key: 0,
        columns: _ctx.columns,
        rows: _ctx.clients,
        pagination: _ctx.pagination,
        "onUpdate:pagination": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.pagination) = $event)),
        loading: _ctx.isLoading
      }, _ctx.$attrs, {
        onRequest: _cache[4] || (_cache[4] = ($event: any) => (_ctx.pagination = $event.pagination))
      }), {
        top: _withCtx(() => [
          _createVNode(_component_add_client_btn, {
            "customer-id": _ctx.customerId,
            label: "Add Client",
            color: "primary",
            rounded: "",
            class: "on-left",
            onAdded: _ctx.prepend
          }, null, 8, ["customer-id", "onAdded"]),
          _createVNode(_component_q_input, {
            modelValue: _ctx.keyword,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keyword) = $event)),
            placeholder: "Name, email, file ref no.",
            "clear-icon": "fa fa-times",
            clearable: "",
            style: {"min-width":"320px"},
            filled: "",
            dense: "",
            autocomplete: "no",
            onClear: _cache[1] || (_cache[1] = ($event: any) => (_ctx.keyword = ''))
          }, {
            prepend: _withCtx(() => [
              _createVNode(_component_q_icon, { name: "fa fa-search" })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        "body-cell-name": _withCtx((props) => [
          _createVNode(_component_q_td, { props: props }, {
            default: _withCtx(() => [
              _createVNode(_component_app_user, null, {
                default: _withCtx(({ isServiceProvider }) => [
                  isServiceProvider
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: `/admin/accounts/${props.row.customerId}/clients/${props.row.id}`,
                        class: "link"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(props.value), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : (_openBlock(), _createBlock(_component_router_link, {
                        key: 1,
                        to: {name: 'client_profile', params: {clientId: props.row.id}},
                        class: "link",
                        title: "View Profile"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(props.value), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["props"])
        ]),
        "body-cell-status": _withCtx((props) => [
          _createVNode(_component_q_td, { props: props }, {
            default: _withCtx(() => [
              _createVNode(_component_user_status, {
                user: props.row.user,
                "onUpdate:user": [
                  ($event: any) => ((props.row.user) = $event),
                  _cache[2] || (_cache[2] = ($event: any) => (_ctx.setUser($event)))
                ],
                "user-type": "Client"
              }, null, 8, ["user", "onUpdate:user"])
            ]),
            _: 2
          }, 1032, ["props"])
        ]),
        "body-cell-createdAt": _withCtx((props) => [
          _createVNode(_component_q_td, { props: props }, {
            default: _withCtx(() => [
              _createVNode(_component_humanize_time, {
                time: props.value
              }, null, 8, ["time"])
            ]),
            _: 2
          }, 1032, ["props"])
        ]),
        "body-cell-actions": _withCtx((props) => [
          _createVNode(_component_q_td, { props: props }, {
            default: _withCtx(() => [
              _createVNode(_component_actions_dropdown, {
                client: props.row,
                onEdited: _ctx.set,
                onDeleted: _ctx.remove
              }, null, 8, ["client", "onEdited", "onDeleted"])
            ]),
            _: 2
          }, 1032, ["props"])
        ]),
        _: 1
      }, 16, ["columns", "rows", "pagination", "loading"]))
    : _createCommentVNode("", true)
}